/* eslint-disable no-param-reassign */

const initialState = () => ({
  targetImageSlug: null,
});

export { initialState as state };

export const mutations = {
  updateTargetImageSlug(state, data) {
    state.targetImageSlug = data;
  },
};

export const actions = {
  openModalToImage({ commit }, { targetImageSlug }) {
    commit('updateTargetImageSlug', targetImageSlug);
  },
  closeModal({ commit }) {
    commit('updateTargetImageSlug', null);
  },
};
